import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=52e5a5d7"
import script from "./VersionCard.vue?vue&type=script&lang=js"
export * from "./VersionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports